
<template>
  <el-dialog title="导入学员" :visible.sync="showimport"  width="40%" class="import_dialog" :show-close='false' :close-on-click-modal="false">
    <el-form :model="form" :label-width="formLabelWidth"  :rules="rules" enctype="multipart/form-data">
      <el-form-item label="班级" v-if="type === 'period'">
        <el-select v-model="form.group_id" filterable placeholder="请选择班级">
          <el-option :label="item.name" :value="item.id" v-for="(item,index) in classArr" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="学员数据" prop="file">
        <div class="file">
          <el-button type="primary" v-model="form.file" >上传文件</el-button>
          <input type="file" name="file" id="file" accept=".xlsx, .xls, .csv, .xlt, .xlm" @change="changeFile($event)"/>
        </div>
        <span class="file_name">{{name}}</span>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="concel">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
// @ is an alias to /src
export default {
  name: 'importStudent',
  components: {
  },
  data(){
    return {
      formLabelWidth: '100px',
      form:{
        period_id:this.id,
        group_id:'',
        file:''
      },
      classArr:[],
      rules:{
        file:[{ required: true, message: '请上传学员数据文件', trigger: 'change' }],
      },
      name:''
    }
  },
  props:{
    showimport:{
      type:Boolean,
      default:Boolean
    },
    id:{
      type:String
    },
    type:{
      type:String
    },
  },
  created(){
    let classParams = {
        period_id:Number(this.id)
      }
      this.obtainClass(classParams)
  },
  mounted(){
  },
  methods:{
    obtainClass(params){
      this.$api.user.classSelectList(params)
      .then(res=>{
        if(res.code === 0){
          this.classArr = res.result
        }
      }) 
    },
    confirm(){
      this.$emit('importConfirm',this.form)
    },
    concel(){
      this.$emit('importConcel')
    },
    changeFile(e){
      let value = e.target.files[0]
      this.name = value.name
      this.form.file = value
      this.$emit('importFile',value)
    },
  },
    
}
</script>
<style lang="scss" scoped>
  // @import '../../../assets/scss/content.scss';
  .import_dialog .el-select{
    width:90%;
  }
  .file_name{
    padding-left:10px;
  }
  .file{
    width:100px;
    height:40px;
    position: relative;
    cursor: pointer;
    display: inline-block;
    input{
      position: absolute;
      top:0;
      left:0;
      right:0;
      bottom:0;
      width:100%;
      height:100%;
      opacity: 0;
      filter: opacity(0);
      font-size: 0;
      z-index:3;
    }
    button{
      z-index:1;
    }
  }
</style>